export const CLEANING_GUIDE_MARINE_GENERAL_GTAG = "GTM-W8MR8R65"

export const LANDING_CLEANING_GUIDE_MARINE_URL = "cleaning-guide-marine"
export const CLEANING_GUIDE_MARINE_GENERAL_URL = "general"
export const CLEANING_GUIDE_MARINE_CHIL_URL = "chil"
